<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LcFw8S/tc-custom/9781781314791.jpg?1695277438098" alt="This image is the cover for the book Royalty Inc."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Royalty Inc.
      </h1>
      <p class="bookDescription body article font2">
        <b>The former <i>Guardian</i> royal correspondent “wisely explores a host of issues surrounding the royals, from the monarchy’s role to the legacy of Diana” (<i>Get Surrey</i>).</b><br/><br/>It was an amazing feat in the twenty-frst century that Queen Elizabeth II, a small woman in her late-eighties, was one of the most recognisable people on the planet. The world had utterly, irreversibly, and radically evolved since she ascended the throne in 1952 and yet, in an era of instant celebrity, she remained, more popular than ever: a bastion of certainty and comfort to the British and many other people during uncertain times. But with her death on September 8, 2022, questions remain: How secure is the British Royal Family? How much depended on the person of the Queen herself, and how much on the institution?<br/><br/>To answer these questions, <i>Royalty Inc.</i> combines a history of the British Crown’s evolution through the modern age with a journalistic peek behind the curtain at the machinery that sustains the Windsors today. Written by the <i>Guardian</i>’s former Royal correspondent, its line is neither royalist nor republican. Instead it takes a clear-eyed look at a host of issues, including the future of the Commonwealth, the Monarchy’s role in the British constitution and class system, King Charles’ notorious “black spider memos,” the true scale of the Royal finances, the legacy of Diana, and the problems and pressures faced by any heir to the throne in the future.<br/><br/><b>“Fearless and perceptive . . . Stephen Bates tells it like it is, covering every aspect with rare humour and intelligence. I couldn’t recommend it more highly.” —<i>Literary Review</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Bates
      </h2>
      
      <p class="authorDescription body article">Stephen Bates is a British journalist and author who has been fascinated by the American Civil War and the pioneering Victorian photographers for many years, and this story combines his two enthusiasms. He lives in England but knows the US well. This is his first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aurum Press Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57f2a69e